import * as Dialog from '@radix-ui/react-dialog'
import { ui } from '@utils/i18n/uiCopy'
import { create } from 'zustand'

type ArmRestrictionNoticeState = {
  open: boolean
  message: string
  show: (message: string) => void
  dismiss: () => void
}

export const useArmRestrictionNotice = create<ArmRestrictionNoticeState>((set) => ({
  open: false,
  message: '',
  show: (message) => set({ open: true, message }),
  dismiss: () => set({ open: false, message: '' }),
}))

export const showArmRestrictionNotice = (message: string) =>
  useArmRestrictionNotice.getState().show(message)

export function ArmRestrictionNoticeModal() {
  const open = useArmRestrictionNotice((s) => s.open)
  const message = useArmRestrictionNotice((s) => s.message)
  const dismiss = useArmRestrictionNotice((s) => s.dismiss)

  return (
    <Dialog.Root open={open} onOpenChange={(next) => !next && dismiss()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[200] bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-[201] w-[min(92vw,26rem)] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 shadow-xl">
          <Dialog.Title className="sr-only">{ui('armRestrictionTitle')}</Dialog.Title>
          <p className="text-center text-sm leading-relaxed text-gray-800">{message}</p>
          <div className="mt-6 flex justify-center">
            <button
              type="button"
              className="rounded-md bg-gray-500 px-6 py-2 text-sm font-medium text-white hover:bg-gray-600"
              onClick={dismiss}
            >{ui('accept')}</button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
